// extracted by mini-css-extract-plugin
export default {"mainCont":"OrderHistory_mainCont__sXkgX","TableDiv":"OrderHistory_TableDiv__zz91d"};